import React from "react";
import {
  Typography,
  Grid,
  Paper,
  Accordion,
  AccordionSummary,
  AccordionDetails,
} from "@material-ui/core";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import { makeStyles } from "@material-ui/core/styles";
import { useTranslation } from "react-i18next";

const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
    marginTop: theme.spacing(5),
  },
  heading: {
    fontSize: theme.typography.pxToRem(15),
    fontWeight: theme.typography.fontWeightRegular,
    fontFamily: "Poppins",
  },
}));

const Faq = () => {
  const { t } = useTranslation();
  const classes = useStyles();

  const faq = [
    { question: `${t("how-to-apply")}`, answer: `${t("answer-how-to-apply")}` },
    {
      question: `${t("eligibility-criteria")}`,
      answer: (
        <Typography className={classes.heading}>
          <ul>
            <li>{t("requirement-one")} </li>
            {/* <li>{t("requirement-two")}</li> */}

            {/* <li>{t("requirement-three")}</li> */}

            <li>{t("requirement-four")}</li>
            {/* <li>{t("requirement-five")}</li> */}
          </ul>
        </Typography>
      ),
    },
    {
      question: `${t("support-documents")}`,
      answer: (
        <Typography className={classes.heading}>
          <ul>
            <li>{t("document-one")} </li>
            {/* <li>{t("document-two")}</li> */}
          </ul>
        </Typography>
      ),
    },
    // {
    //   question: `${t("how-to-select")}`,
    //   answer: `${t("answer-how-to-select")}`,
    // },
    // {
    //   question: `${t("allowed-to")}`,
    //   answer: `${t("answer-allowed-to")}`,
    // },
  ];
  return (
    <div className={classes.root} data-aos="fade-up" data-aos-delay="500">
      <Typography
        variant="h4"
        gutterBottom={true}
        style={{
          fontFamily: "Poppins",
          padding: "10px",
          textTransform: "uppercase",
        }}
        align="center"
      >
        {t("frequently-title")}
      </Typography>
      {faq.map((f, i) => (
        <Accordion key={i}>
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel1a-content"
            id="panel1a-header"
          >
            <Typography className={classes.heading}>
              <strong>{f.question}</strong>
            </Typography>
          </AccordionSummary>
          <AccordionDetails>{f.answer}</AccordionDetails>
        </Accordion>
      ))}
    </div>
  );
};

export default Faq;
